import moment from "moment"
import {
    getDataSourceLabel,
  } from "../utils/function"
import { convertNumber, useHandleAuth } from "utils"
import { SpendMoney } from "../types"



interface ItemProps {
    index: number,
    item: SpendMoney
}



export function ItemOpBalance({ item,index }: ItemProps) {
  const auth = useHandleAuth()
  const token = auth.userTokenData()
    return (
      <tr key={index}>
        <td className="font-normal text-nowrap">
          <span className="pe-2">{getDataSourceLabel(0)}</span>
        </td>
  
        <td className="font-normal text-nowrap">
          <span className="ps-4">
            {moment(new Date()).format("DD/MM/YYYY")}
          </span>
        </td>
  
        <td className="text-center">
          {/* RC */}
        </td>
  
        <td>Company</td>
  
        <td className="text-uptext-transform: uppercase">{token?.company_name}</td>
  
        <td>
          
        </td>
  
        <td>Opening Balance</td>
  
        <td className="text-right">
          
        </td>
  
        <td className="text-right">
          {convertNumber(item.Balance).intoCurrency}
        </td>
      </tr>
    )
  }